import {
  ContractCard as DesignSystemContractCard,
  DeleteIcon,
  EditIcon,
  ResourceMenuActions,
} from '@all-manager/design-system-v2';
import { ProviderContractDatabase } from "../../../../../types";
import AddUpdateContractModal from "../../AddUpdateContractModal/AddUpdateContractModal";
import DeleteContractModal from "../../DeleteContractModal/DeleteContractModal";
import { useContractCard } from "./useContractCard";

type Props = {
  contract: ProviderContractDatabase;
}

export default function ContractCard(props: Props) {
  const hook = useContractCard(props);

  return (
    <>
      <DesignSystemContractCard
        title={props.contract.name}
        status={hook.status}
        startDate={props.contract.start_at}
        endDate={hook.endDate}
        renewalLabel={hook.renewalLabel}
        noticePeriod={props.contract.period_of_notice}
        price={props.contract.price}
        description={props.contract.description}
        documentUrl={props.contract.file_url}
        action={hook.isAdmin ? (
          <ResourceMenuActions
            size="small"
            tooltip="Options du contrat"
            actions={[
              { id: 'edit', label: 'Modifier', icon: <EditIcon fontSize="small" />, onClick: hook.handleOpenEditModal },
              { id: 'delete', label: 'Supprimer', icon: <DeleteIcon fontSize="small" />, onClick: hook.handleOpenDeleteModal },
            ]}
          />
        ) : undefined}
      />

      {hook.isEditModalOpen ? (
        <AddUpdateContractModal
          onClose={hook.handleCloseEditModal}
          providerId={props.contract.provider_id}
          contract={props.contract}
        />
      ) : null}

      {hook.isDeleteModalOpen ? (
        <DeleteContractModal
          contract={props.contract}
          onClose={hook.handleCloseDeleteModal}
        />
      ) : null}
    </>
  );
}
